export default __webpack_public_path__ + "static/media/parallelogram.1f171c9e.svg";